import { Toast } from 'vant';

const getMainPageIframe = () => {
  if (!getMainPageIframe.iframePromise) {
    getMainPageIframe.iframePromise = new Promise(resolve => {
      const iframe = document.createElement('iframe');
      iframe.src = location.origin + '/XV/UI/Home?noheader=1#app/standalone/mainpageoperator';
      // iframe.src = 'https://crm.ceshi112.com/XV/UI/Home?noheader=1#app/standalone/mainpageoperator';
      Object.assign(iframe.style, {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        zIndex: 99,
        display: 'none',
      });
      document.body.appendChild(iframe);
      window.addEventListener('message', event => {
        if (event.data && event.data.form === 'main-page-operator' && event.data.data === 'page-ready') {
          resolve(iframe);
        }
      });
    });
  }
  return getMainPageIframe.iframePromise;
};
export default {
  preLoad() {
    return getMainPageIframe();
  },
  $show(params) {
    Toast.loading({
      message: '加载中...',
      duration: 0,
    });
    getMainPageIframe()
      .finally(() => {
        Toast.clear();
      })
      .then(iframe => {
        iframe.style.display = 'block';
        iframe.contentWindow.FS.MEDIATOR.trigger('qx.forwardMessage.sendExternalNewsMessage', {
          title: params.title,
          summary: params.summary,
          resource: params.url,
          afterSend: () => {
            this.$hide();
          },
        });
      });
  },
  $hide() {
    getMainPageIframe().then(iframe => {
      iframe.src = 'https://crm.ceshi112.com/XV/UI/Home?noheader=1#app/standalone/mainpageoperator';
      iframe.style.display = 'none';
    });
  },
};
